import { render, staticRenderFns } from "./eulaContent.vue?vue&type=template&id=330faf2d&scoped=true"
import script from "./eulaContent.vue?vue&type=script&lang=js"
export * from "./eulaContent.vue?vue&type=script&lang=js"
import style0 from "./eulaContent.vue?vue&type=style&index=0&id=330faf2d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "330faf2d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard,VCardText})
